import { render, staticRenderFns } from "./RecomendationList.vue?vue&type=template&id=46cffc86&scoped=true&"
import script from "./RecomendationList.vue?vue&type=script&lang=js&"
export * from "./RecomendationList.vue?vue&type=script&lang=js&"
import style0 from "./RecomendationList.vue?vue&type=style&index=0&id=46cffc86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cffc86",
  null
  
)

export default component.exports